var React = require('react');
var Radium = require('radium');

var style = {
	base: {
		flex: '1 1 15%',
		display: 'flex',
		alignItems: 'center'
	},

	badge: {
		border: 'solid 1px #03a6dc',
    	padding: '0px 5px',
    	borderRadius: '50%',
    	fontWeight: 'bold',
    	marginRight: '5px'
	},

	even: {
		color: '#03a6dc',
		backgroundColor: 'transparent'
	},

	odd: {
		color: '#fff',
		backgroundColor: '#03a6dc'
	},

	address: {
		display: 'flex',
		justifyConten: 'space-between',
		alignItems: 'center'
	}
};

var BadgeAddress = Radium(React.createClass({

	getLabel: function(order) {
		var label;

		switch(order) {
			case 1:
				label = 'B';
				break;

			case 2:
				label = 'C';
				break;

			case 3:
				label = 'D';
				break;

			default:
				label = 'A';
				break;
		}

		return label;
	},

	getDefaultTitle: function() {
		return  (
			<span>{this.props.title}</span>
		)
	},

	getAddressTitle: function() {
		var me = this;

		return (
			<div style={style.address} >
				<span>{me.props.address}</span>
			</div>
		)
	},

	render: function() {
		var me = this, order = me.props.order, title = me.getDefaultTitle();

		if (me.props.collapsed === false && me.props.address) {
			title = me.getAddressTitle()
		}

		return (
			<div style={style.base}>
				<span style={order % 2 ? [style.badge, style.odd] : [style.badge, style.even]}>
					{me.getLabel(order)}
				</span>

				{title}
			</div>
		);
	}

}));

module.exports = BadgeAddress;


// WEBPACK FOOTER //
// ./src/components/Client/BadgeAddress.jsx